export const ONBOARDINGS_ID = 'onboardings';

/** `onboarding_id` value of the tab that shows live data across all onboardings. */
export const CURRENT_ONBOARDING_ID = 'current';

export const getSubsectionAnchorId = (subsection: string) => `onboarding-${subsection}`;
